import { Input, TimePicker, Button, Table } from "@ds/ds-snam/react";
import { INotificationAction } from "dataModels/stateModels/notification";
import { IMoveReservationParameters, IParametersFreezing, IShipper} from "dataModels/settings";
import moment from "moment";
import { getParametersFreezing, getShipperList, putParametersFreezing } from "net/settings";
import React, { useCallback, useEffect, useState } from "react";
import { Col, Row } from "react-grid-system";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { AppUserRole, DsLayout, EntityType, IAppUserProfile, RequestStatus, TIME_FORMAT } from "shared/constants";
import { hideNotification, showNotification } from "state/reducer/notificationSlice";
import { requestPending, requestPristine } from "state/reducer/requestStatusSlice";
import { RootState } from "state/appStore";
import useAppUser from "hooks/useAppUser";
import { AppUser } from "ooAuth2/appUser";
import useRequestStatus from "hooks/useRequestStatus";
import NoDataFound from "components/NoDataFound";
import { ITableConfig, ITableRow } from "@ds/ds-snam/dist/models/tables";
import { getDSTableSharedElements, getTableCellsHeaderSimple } from "shared/utils/dsComponentUtils";
import AddEntityButton from "components/AddEntityButton";
import { useNavigate } from "react-router";



const ShipperView:React.FC<{}> = ():JSX.Element=>{
    const [shipperList,setShipperList] = useState<IShipper[]>([]);

    const dispatch = useDispatch();
    const { t } = useTranslation(['contract', 'app']);
    const layoutMode = useSelector((state:RootState)=>{
        return state.dsLayout.mode;
    })
    const appUser: AppUser | undefined = useAppUser();
    const appUserRole: AppUserRole | undefined = appUser?.getRole();
    const appUserProfile: IAppUserProfile | undefined = appUser?.userProfile;
    const requestStatus = useRequestStatus();
    const navigate = useNavigate();
    const loadData = useCallback(() => {
        dispatch(requestPending());
        getShipperList()
            .then((data: IShipper[]) => {
                setShipperList(data);
            })
            .catch((error) => {
                console.log(error)
            })
            .finally(() => {
                dispatch(requestPristine())
            })
    }, [dispatch]);

    useEffect(() => {
        loadData()
    }, [loadData]);
    
    const putData = ()=>{

    }
    const getTableRowsShippers = (): ITableRow[] => {
                  let myRetArr: ITableRow[] = [];
                  for (let i in shipperList) {
                      let tempObj: ITableRow = {
                          tableCells: [
                              { 
                                  type: "text", 
                                  text: shipperList[i].shipperName?.toString(),
                              },
                              { 
                                  type: "text", 
                                  text: shipperList[i].shipperCode?.toString(),
                              },
                          ],
                          rightIcon: "icon-chevron-right",
                      };
                      myRetArr.push(tempObj);
                  }
                  return myRetArr;
          };

    const myTableConfigShippers: ITableConfig = {
                ...getDSTableSharedElements(560),
                tableHeader: {
                    tableCellsHeader: [
                        getTableCellsHeaderSimple(t('settings.shipperParameters.labels.0', { ns: 'contract' }),"col1","50%","left"),
                        getTableCellsHeaderSimple(t('settings.shipperParameters.labels.1', { ns: 'contract' }),"col2","50%","left")
                    ],
                    hasSearchBox: true,
                },
                tableRows: getTableRowsShippers(),
        };
  
    return(
        <>
            <p className="pageTitle">
                {t('settings.shipperParameters.title1', { ns: 'contract' })} 
            </p>
            {/*appUserProfile?.addEntityPolicy.includes(EntityType.CONTRACT) &&*/ (
                <div
                style={{
                    marginTop: "28px",
                    marginBottom: "14px",
                    display: "flex",
                    alignItems: "flex-start",
                    justifyContent: "flex-end",
                }}
                >
                    <AddEntityButton entityType={EntityType.SHIPPER} />
                </div>
            )}
            {shipperList && shipperList.length ? (
            <>
                {
                    <Table 
                        tableConfig={myTableConfigShippers} 
                        style={{}}
                        onInputSearchBarChange={(event:Event)=>{
                        }}
                        onResetSearch={(event:Event)=>{
                        }}
                        onSubmitSearchedText={(event:Event)=>{
                        }}
                        onClickRightAction={(event:Event)=>{
                            navigate(shipperList[(event as CustomEvent).detail.row].shipperId.toString(),{state:{shipper:shipperList[(event as CustomEvent).detail.row]}});
                        }}
                        onTableInputChange={(event:Event)=>{
                        }}
                        onColumnSorting={(event:Event)=>{
                        }}
                    />
                }
            </>
        ) : requestStatus === RequestStatus.SUCCESS ? (
            <NoDataFound
                title={t('settings.shipperParameters.labels.3', { ns: 'contract' })} 
                subTitle={t('settings.shipperParameters.labels.4', { ns: 'contract' })} 
            />
        ) : (
            <></>
        )}
        </>
    );
}
export default ShipperView;

